<template>
  <div class="join-wrap">
    <div class="join-img">
      <div class="bacImg"></div>
      <p class="h1">{{$t('menu.job')}} <a href="https://www.hotjob.cn/wt/BCSC/web/index" target="_blank"><i
            class="iconfont iconjob_offers"></i></a></p>
    </div>
    <!-- 公司介绍 -->
    <!--<ComInfo></ComInfo>-->
    <!-- 我们的核心价值观 -->
    <Core></Core>
    <!-- 我们的使命 -->
    <Mission></Mission>
    <!-- 招聘 -->
    <Join></Join>
  </div>
</template>
<script>
import Core from "./component/core";
import ComInfo from "./component/com-info";
import Join from "./component/join";
import Mission from "./component/mission";
export default {
  components: { Core, ComInfo, Join, Mission }
};
</script>
<style lang="less" scoped>
@import "../../style/constant";

.join-wrap {
  background-color: #ffffff;
  width: 100%;

  .join-img {
    position: relative;

    .bacImg {
      height: 480px;
      background: url("../../../src/assets/bac.jpg") center center no-repeat;
      background-size: cover;
      width: 100%;
    }

    a {
      text-decoration: none;
    }

    .iconjob_offers {
      font-size: 46px;
      color: #e76c5e;

      &:hover {
        cursor: pointer;
      }
    }

    .h1 {
      position: absolute;
      font-size: 60px;
      color: @h1-color;
      font-weight: 500;
      top: 40%;
      right: 15%;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 480px)  {
    h2 {
      font-size: 25px;
    }
    .join-img {
      .h1 {
        font-size: 34px;
      }

      .iconjob_offers {
        font-size: 24px;
      }

      .bacImg {
        display: flex;
        align-items: center;
        height: 40vh;
        background: url("../../../src/assets/join-phone-2.jpg") center center no-repeat;
        background-size: cover;

        .title {
          color: #ffffff;
        }
      }
    }
  }
}
</style>
